import React, { useEffect, useRef, useState } from 'react';
import {
  Container,
  LeftSide,
  RightSide,
  Header,
  TabName,
  Name,
  Title,
  Info,
  ProfileHeader,
  InfoContainer,
  Gap,
  Row,
  ProfilePhoto,
  Dropdown,
  DropdownContainer,
  DropText,
  DropValue,
  ListContainer,
  RowIcon,
  TooltipCard,
  TooltipBox,
  ToolTipTitle,
  ClientProfilePhoto,
  CurrentDropValue,
  TextArea,
  HashtagsContainer,
  HashtagName,
  HashtagContainer,
  StyledInput,
  ClientHashtagsContainer,
  HashContainer,
  DeleteText,
} from './ClientDetails.styles';
import { ReactComponent as Edit } from '../../../assets/icons/edit.svg';
import { ReactComponent as User } from '../../../assets/icons/user.svg';
import { ReactComponent as InfoCircle } from '../../../assets/icons/infoCircle.svg';
import { ReactComponent as Down } from '../../../assets/icons/chevronDown.svg';
import Contracts from './Contracts';
import Payments from './Payments';
import ToDos from './ToDos';
import Appointments from './Appointments';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeStatusForClient,
  createHashtagsForClient,
  getClientById,
  setNoteForClient,
} from '../../../store/slice/vendor/asyncThunks';
import {
  selectClient,
  selectClientData,
  selectCreateClientHashtagsPending,
  selectDeleteLeadClientPending,
} from '../../../store/slice/vendor/slice';
import { Waveform } from '@uiball/loaders';
import { dateFormatter } from '../../../utils/utils';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ModalComponent from '../../../components/Modal/ModalComponent';
import { CLIENT_STATUS, CLIENT_STATUSES } from '../../../utils/constants';
import { ReactComponent as X } from '../../../assets/icons/closeModal.svg';
import { notifyError, notifyErrorLeft, notifyInfo } from '../../../utils/notify';
import DatePicker from 'react-datepicker';
import { IconPosition } from '../../CalendarPage/CalendarPage.styles';
import { ReactComponent as Calendar } from '../../../assets/icons/date.svg';
import {
  selectSendDeleteRequestToClientPending,
  selectSetClientWeddingDatePending,
} from '../../../store/slice/wedding/slice';
import {
  deleteLeadClient,
  sendDeleteRequestToClient,
  setClientWeddingDate,
} from '../../../store/slice/wedding/asyncThunks';

import {
  Background,
  ButtonContainerGap,
  ButtonText,
  ModalTitleSmall,
  SmallModalContainer,
  StyledButton,
} from '../../../components/Modal/ModalComponent.styles';
import { selectDeleteClientPaymentPending } from '../../../store/slice/payment/slice';
import { deleteClientPayment, getClientPayment } from '../../../store/slice/payment/asyncThunks';

const ClientDetails = () => {
  let [searchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const id = searchParams.get('id');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const clientInfo = useSelector(selectClientData);
  const client = useSelector(selectClient);
  const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [note, setNote] = useState(clientInfo.note);
  const clientStatuses = CLIENT_STATUSES;

  const [isHashtagModalOpen, setIsHashtagModalOpen] = useState(false);
  const [hashtags, setHashtags] = useState([]);
  const [clientHashtags, setClientHashtags] = useState([]);
  const createClientHashtagsPending = useSelector(selectCreateClientHashtagsPending);

  const [hashtagInput, setHashtagInput] = useState('');

  const [isWeddingDateModalOpen, setIsWeddingDateModalOpen] = useState(false);
  const [weddingDate, setWeddingDate] = useState();
  const datePickerRef = useRef(null);
  const setClientWeddingDatePending = useSelector(selectSetClientWeddingDatePending);
  const deleteLeadClientPending = useSelector(selectDeleteLeadClientPending);
  const sendDeleteRequestToClientPending = useSelector(selectSendDeleteRequestToClientPending);

  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  useEffect(() => {
    dispatch(getClientById(id));
  }, [dispatch, id]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setNote(clientInfo.note);
    setIsModalOpen(false);
  };
  const handleAddNote = () => {
    const data = { id: client.data.weddingVendorId, note: note };
    dispatch(setNoteForClient(data))
      .unwrap()
      .then(() => {
        setNote(note);
        setIsModalOpen(false);
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };

  const handleChangeStatus = status => {
    const data = { id: client.data.weddingVendorId, status: status.value };
    dispatch(changeStatusForClient(data))
      .unwrap()
      .then(() => {
        setIsOpen(false);
      })
      .catch(err => {
        console.log(err);
        notifyError(err.message);
      });
  };

  const handleStatusName = status => {
    if (status === CLIENT_STATUS.ACCEPTED) {
      return 'Active';
    } else if (status === CLIENT_STATUS.COMPLETED) {
      return 'Completed';
    } else if (status === CLIENT_STATUS.LEAD) {
      return 'Lead';
    }
  };

  const openHashtagModal = () => {
    setIsHashtagModalOpen(true);
    setClientHashtags(clientInfo.hashtags);
  };

  const closeHashtagModal = () => {
    setHashtagInput('');
    setHashtags([]);
    setClientHashtags([]);
    setIsHashtagModalOpen(false);
  };

  const handleAddHashtag = hashtag => {
    setHashtagInput('');
    const founded = hashtags.find(item => item.name === hashtag);
    if (!founded && hashtag) {
      setHashtags(prev => {
        return [{ name: hashtag }, ...prev];
      });
    }
  };
  const handleRemoveHashtag = hashtag => {
    let filteredArray = hashtags.filter(item => item.name !== hashtag.name);
    setHashtags(filteredArray);
  };

  const handleRemoveFromClientHashtags = hashtag => {
    let filteredArray = clientHashtags.filter(item => item.id !== hashtag.id);
    setClientHashtags(filteredArray);
  };
  const handleCreateHashtags = () => {
    const data = {
      id: clientInfo.weddingVendorId,
      hashtags: clientHashtags,
      newHashtags: hashtags,
    };
    dispatch(createHashtagsForClient(data))
      .unwrap()
      .then(() => {
        closeHashtagModal();
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };

  const openWeddingDateModal = () => {
    setIsWeddingDateModalOpen(true);
    setWeddingDate(clientInfo.weddingDate && new Date(clientInfo.weddingDate));
  };
  const closeWeddingDateModal = () => {
    setIsWeddingDateModalOpen(false);
    setWeddingDate();
  };
  const handleSetWeddingDate = () => {
    const data = {
      id: clientInfo.id,
      body: {
        dateOfWedding: weddingDate.getTime(),
      },
    };
    dispatch(setClientWeddingDate(data))
      .unwrap()
      .then(() => {
        notifyInfo('Successfully set client wedding date');
        closeWeddingDateModal();
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };

  const deleteClientPaymentPending = useSelector(selectDeleteClientPaymentPending);
  const [isVisible, setIsVisible] = useState(false);
  const [deleteClient, setDeleteClient] = useState(false);
  const [clickedDeleteId, setClickedDeleteId] = useState(null);

  const handleDeletePayment = () => {
    dispatch(deleteClientPayment({ id: clickedDeleteId }))
      .unwrap()
      .then(() => {
        setClickedDeleteId(null);
        dispatch(getClientPayment({ id: id }))
          .unwrap()
          .then(() => {});
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };

  const handleDeleteLeadClient = () => {
    dispatch(deleteLeadClient({ id: id }))
      .unwrap()
      .then(() => {
        setIsVisible(false);
        setDeleteClient(false);
        notifyInfo('Client successfully deleted');
        navigate({
          pathname: '/clients',
          search: `?page=1`,
        });
      })
      .catch(err => {
        console.log(err);
        notifyError(err.message);
      });
  };

  const handleSendDeleteRequestToClient = () => {
    dispatch(sendDeleteRequestToClient({ id: id }))
      .unwrap()
      .then(() => {
        setIsVisible(false);
        setDeleteClient(false);
        notifyInfo(
          'Your request to remove your client has been received. As soon as the client agrees with this they will be removed.',
        );
      })
      .catch(err => {
        console.log(err);
        notifyError(err.message);
      });
  };

  const handleDeleteClientClick = () => {
    if (!clientInfo.onboardingFinishedAt) {
      handleDeleteLeadClient();
    } else {
      handleSendDeleteRequestToClient();
    }
  };

  return (
    <Container>
      <LeftSide $loading={client.getClientByIdPending}>
        {!client.getClientByIdPending ? (
          <>
            <ProfileHeader>
              {clientInfo?.profilePhoto !== null ? (
                <ClientProfilePhoto src={clientInfo.profilePhoto} alt="profilePhoto" width={32} height={32} />
              ) : (
                <ProfilePhoto>
                  <User width={20} height={20} />
                </ProfilePhoto>
              )}
              <Name>{`${clientInfo.firstName} ${clientInfo.lastName}`}</Name>
            </ProfileHeader>
            <InfoContainer>
              <Gap>
                <Title>Phone Number</Title>
                <Info>{clientInfo.phoneNumber}</Info>
              </Gap>
              <Gap>
                <Title>Email</Title>
                <Info>{clientInfo.email}</Info>
              </Gap>
              <Gap>
                <Title>Client Since</Title>
                <Info>{`${dateFormatter(clientInfo.clientSince)}`}</Info>
              </Gap>
              <Gap>
                <Row>
                  <Title>Wedding Date</Title>

                  {!clientInfo.onboardingFinishedAt && <Edit className="icon-edit" onClick={openWeddingDateModal} />}
                </Row>
                <Info>{clientInfo.weddingDate && `${dateFormatter(clientInfo.weddingDate)}`}</Info>
              </Gap>
              <Gap>
                <Row>
                  <TooltipCard>
                    <RowIcon>
                      <Title>Notes</Title>
                      <InfoCircle />
                    </RowIcon>
                    <TooltipBox>
                      <ToolTipTitle>Notes are NOT visible to clients</ToolTipTitle>
                    </TooltipBox>
                  </TooltipCard>

                  <Edit className="icon-edit" onClick={openModal} />
                </Row>
                <Info>{clientInfo.note}</Info>
              </Gap>
              <Gap>
                <Row>
                  <Title onClick={openHashtagModal}>Hashtags</Title>
                  <Edit className="icon-edit" onClick={openHashtagModal} />
                </Row>
                <ClientHashtagsContainer>
                  {clientInfo.hashtags?.slice(0, 3).map(item => (
                    <HashContainer key={item.id}>
                      <Info>{`#${item.name}`}</Info>
                    </HashContainer>
                  ))}
                  {clientInfo.hashtags?.length > 3 && <Info>{'...'}</Info>}
                </ClientHashtagsContainer>
              </Gap>
              <Gap>
                <DropdownContainer>
                  <Dropdown onClick={toggleDropdown} $open={isOpen}>
                    {clientInfo.clientStatus ? (
                      <Row>
                        <CurrentDropValue>{handleStatusName(clientInfo.clientStatus)}</CurrentDropValue>
                        <Down />
                      </Row>
                    ) : (
                      <Row>
                        <DropText>Select Status</DropText>
                        <Down />
                      </Row>
                    )}
                  </Dropdown>
                  {isOpen && (
                    <ListContainer>
                      {clientStatuses.map((e, index) => {
                        return (
                          <DropValue onClick={() => handleChangeStatus(e)} key={index}>
                            {e.label}
                          </DropValue>
                        );
                      })}
                    </ListContainer>
                  )}
                </DropdownContainer>
              </Gap>

              <DeleteText
                onClick={() => {
                  setIsVisible(true);
                  setDeleteClient(true);
                }}>
                Delete this client
              </DeleteText>
            </InfoContainer>
          </>
        ) : (
          <Waveform size={40} lineWeight={3.5} speed={1} color="black" />
        )}
      </LeftSide>
      <RightSide>
        <Header
          $selected={tabParam === 'contracts'}
          $payment={tabParam === 'payments'}
          $appointments={tabParam === 'appointments'}>
          <TabName
            $selected={tabParam === 'contracts'}
            onClick={() => {
              navigate({
                pathname: '/clients',
                search: `?screen=details&id=${id}&tab=contracts`,
              });
            }}>
            Client Documents
          </TabName>
          <TabName
            $payment={tabParam === 'payments'}
            onClick={() => {
              navigate({
                pathname: '/clients',
                search: `?screen=details&id=${id}&tab=payments`,
              });
            }}>
            Payments
          </TabName>
          <TabName
            $selected={tabParam === 'toDos'}
            onClick={() => {
              navigate({
                pathname: '/clients',
                search: `?screen=details&id=${id}&tab=toDos`,
              });
            }}>
            To Do's
          </TabName>
          <TabName
            $appointments={tabParam === 'appointments'}
            onClick={() => {
              navigate({
                pathname: '/clients',
                search: `?screen=details&id=${id}&tab=appointments`,
              });
            }}>
            Appointments
          </TabName>
        </Header>
        {tabParam === 'contracts' && <Contracts id={id} />}
        {tabParam === 'payments' && (
          <Payments
            id={id}
            setIsVisible={setIsVisible}
            deleteClientPaymentPending={deleteClientPaymentPending}
            clickedDeleteId={clickedDeleteId}
            setClickedDeleteId={setClickedDeleteId}
          />
        )}
        {tabParam === 'toDos' && <ToDos id={id} />}
        {tabParam === 'appointments' && <Appointments id={id} />}
      </RightSide>

      <ModalComponent
        isOpen={isModalOpen}
        onClose={closeModal}
        title={'Add note'}
        onCreate={handleAddNote}
        width={'800px'}>
        <TextArea type="text" placeholder="Write note" onChange={n => setNote(n.target.value)} value={note} />
      </ModalComponent>

      <ModalComponent
        isOpen={isHashtagModalOpen}
        onClose={closeHashtagModal}
        subtitle={'Press enter to add a hashtag'}
        title={'Hashtags'}
        onCreate={handleCreateHashtags}
        width={'800px'}
        rightButtonTitle={'Save'}
        createDisabled={!clientHashtags.length && !hashtags.length}
        cancelDisabled={createClientHashtagsPending}
        loading={createClientHashtagsPending}>
        <StyledInput
          type="text"
          placeholder="Write hashtag"
          onChange={h => setHashtagInput(h.target.value)}
          value={hashtagInput}
          onKeyDown={e => e.key === 'Enter' && handleAddHashtag(e.target.value)}
        />
        <HashtagsContainer>
          {clientHashtags.map((item, index) => (
            <HashtagContainer key={index} onClick={() => handleRemoveFromClientHashtags(item)}>
              <HashtagName>{`#${item.name}`}</HashtagName>
              <X width={15} height={15} />
            </HashtagContainer>
          ))}
          {hashtags.map((item, index) => (
            <HashtagContainer key={index} onClick={() => handleRemoveHashtag(item)}>
              <HashtagName>{`#${item.name}`}</HashtagName>
              <X width={15} height={15} />
            </HashtagContainer>
          ))}
        </HashtagsContainer>
      </ModalComponent>

      <ModalComponent
        isOpen={isWeddingDateModalOpen}
        onClose={closeWeddingDateModal}
        title={'Set Client Wedding Date'}
        onCreate={handleSetWeddingDate}
        width={'800px'}
        rightButtonTitle={'Save'}
        createDisabled={!weddingDate}
        cancelDisabled={setClientWeddingDatePending}
        loading={setClientWeddingDatePending}>
        <div className="border-bottom">
          <DatePicker
            placeholderText="Wedding Date"
            className="date-picker"
            selected={weddingDate && weddingDate}
            calendarClassName="scale"
            dateFormat="MMMM d, yyyy"
            minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
            onChange={date => setWeddingDate(date)}
            ref={datePickerRef}
          />
          <IconPosition onClick={handleIconClick}>
            <Calendar />
          </IconPosition>
        </div>
      </ModalComponent>

      {isVisible && (
        <>
          <Background $open={isVisible} />
          <SmallModalContainer $open={isVisible}>
            {deleteClient ? (
              <>
                <ModalTitleSmall style={{ textAlign: 'center' }}>
                  Are you sure you want to delete this client?
                </ModalTitleSmall>
                <ButtonContainerGap style={{ gap: 20 }}>
                  <StyledButton
                    onClick={() => {
                      setIsVisible(false);
                      setDeleteClient(false);
                    }}>
                    <ButtonText>Cancel</ButtonText>
                  </StyledButton>

                  <StyledButton
                    onClick={() => {
                      if (!deleteLeadClientPending || !sendDeleteRequestToClientPending) {
                        // handleDeleteLeadClient();
                        handleDeleteClientClick();
                      }
                    }}
                    $disabled={deleteLeadClientPending || sendDeleteRequestToClientPending}
                    $black>
                    {deleteLeadClientPending || sendDeleteRequestToClientPending ? (
                      <Waveform size={26} lineWeight={3.5} speed={1} color="white" />
                    ) : (
                      <ButtonText $black>Yes</ButtonText>
                    )}
                  </StyledButton>
                </ButtonContainerGap>
              </>
            ) : (
              <>
                <ModalTitleSmall style={{ textAlign: 'center' }}>
                  Are you sure you want to delete this payment?
                </ModalTitleSmall>
                <ButtonContainerGap style={{ gap: 20 }}>
                  <StyledButton onClick={() => setIsVisible(false)}>
                    <ButtonText>Cancel</ButtonText>
                  </StyledButton>

                  <StyledButton
                    onClick={() => {
                      if (!deleteClientPaymentPending) {
                        handleDeletePayment();

                        setIsVisible(false);
                      }
                    }}
                    $disabled={deleteClientPaymentPending}
                    $black>
                    {!deleteClientPaymentPending ? (
                      <ButtonText $black>Yes</ButtonText>
                    ) : (
                      <Waveform size={26} lineWeight={3.5} speed={1} color="white" />
                    )}
                  </StyledButton>
                </ButtonContainerGap>
              </>
            )}
          </SmallModalContainer>
        </>
      )}
    </Container>
  );
};

export default ClientDetails;
